<div class="emd-filter-row" [style.--emd-accent]="accentColor || null">
  <span class="emd-filter-label">Selected filters:</span>

  <!-- Scroll arrows, as in widget/filter-badges: shown only when the chip
       strip overflows; each click slides it 150px. -->
  <span
    class="emd-chips-arrow"
    *ngIf="showScrollArrows"
    role="button"
    aria-label="Scroll filters left"
    (click)="scrollChips(-1)"
  >
    <svg width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.79059 7.11381C6.81139 7.06178 6.79965 7.00195 6.76179 6.96215L3.92262 3.99979L6.76151 1.03744C6.79965 0.997648 6.81111 0.93727 6.79058 0.885787C6.77005 0.833757 6.72125 0.799805 6.66739 0.799805L4.26742 0.799805C4.23196 0.799805 4.19808 0.814557 4.17302 0.840435L1.23972 3.9013C1.21386 3.92857 1.20078 3.96418 1.20078 3.9998C1.20078 4.03543 1.21384 4.07103 1.23972 4.09831L4.17302 7.15917C4.19808 7.18505 4.23196 7.1998 4.26742 7.1998L6.66739 7.1998C6.72125 7.19979 6.77005 7.16584 6.79059 7.11381Z" fill="#1363DF"/>
    </svg>
  </span>

  <div class="emd-chips-wrap" #chipsScroll>
    <button
      type="button"
      class="emd-chip"
      *ngFor="let chip of chips"
      [cdkMenuTriggerFor]="badgeMenu"
      (click)="openChip(chip)"
    >
      <span class="emd-chip-label">{{ chip.label }}</span>
      <!-- Multi shows a count badge; single-select shows its picked value,
           matching the filter-badges chip. The badge turns orange when the
           dimension is actively narrowed (selected != all), as in filter-badges. -->
      <span
        class="emd-chip-count"
        *ngIf="chip.multi"
        [class.emd-chip-badge--cut]="chip.selected.length !== chip.options.length"
      >
        {{ chip.selected.length }}/{{ chip.options.length }}
      </span>
      <span class="emd-chip-value" *ngIf="!chip.multi && chip.selected.length">
        {{ chip.selected[0] }}
      </span>
      <mat-icon class="emd-chip-caret">expand_more</mat-icon>
    </button>

    <!-- Time Range: from/to date fields, each opening its own mat-datepicker
         popup (see timecycle-with-range). Self-managed overlay, not a CDK menu. -->
    <button
      type="button"
      class="emd-chip"
      cdkOverlayOrigin
      #dateRangeOrigin="cdkOverlayOrigin"
      [class.emd-chip--range-active]="hasDateRange"
      [attr.aria-expanded]="dateRangeOpen"
      (click)="toggleDateRange()"
    >
      <span class="emd-chip-label">{{ dateRangeLabel }}</span>
      <mat-icon class="emd-chip-caret">expand_more</mat-icon>
    </button>
  </div>

  <span
    class="emd-chips-arrow"
    *ngIf="showScrollArrows"
    role="button"
    aria-label="Scroll filters right"
    (click)="scrollChips(1)"
  >
    <svg width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.20941 7.11381C1.18861 7.06178 1.20035 7.00195 1.23821 6.96215L4.07738 3.99979L1.23849 1.03744C1.20035 0.997648 1.18889 0.93727 1.20942 0.885787C1.22995 0.833757 1.27875 0.799805 1.33261 0.799805L3.73258 0.799805C3.76804 0.799805 3.80192 0.814557 3.82698 0.840435L6.76028 3.9013C6.78614 3.92857 6.79922 3.96418 6.79922 3.9998C6.79922 4.03543 6.78616 4.07103 6.76028 4.09831L3.82698 7.15917C3.80192 7.18505 3.76804 7.1998 3.73258 7.1998L1.33261 7.1998C1.27875 7.19979 1.22995 7.16584 1.20941 7.11381Z" fill="#1363DF"/>
    </svg>
  </span>

  <div class="emd-filter-actions">
    <button type="button" class="emd-reset-btn" (click)="reset.emit()">
      <!-- Same x_mark icon the filter badges widget uses; registered globally
           by IconService from assets/json/icons.json. -->
      <mat-icon class="emd-reset-icon" svgIcon="x_mark"></mat-icon>
      Reset to default
    </button>
    <button
      type="button"
      class="emd-filter-icon-btn"
      *ngIf="showFilterButton"
      (click)="filterClick.emit()"
      aria-label="Filters"
    >
      <mat-icon>filter_list</mat-icon>
    </button>
  </div>
</div>

<!-- Badge dropdown — structure and class names follow filter-badges. -->
<ng-template #badgeMenu>
  <div class="dropdownMenu" cdkMenu (click)="$event.stopPropagation()">

    <div class="header" *ngIf="activeChip?.multi">
      <button
        type="button"
        class="btn include"
        matTooltip="Include"
        matTooltipClass="emd-tip-mat"
        cdkMenuItem
        [class.disabled]="!draft.length"
        [disabled]="!draft.length"
        (click)="apply('include')"
      >
        <svg width="25" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="7" width="8" height="3" fill="#1363DF" />
          <rect x="7" y="12" width="8" height="3" fill="#1363DF" />
          <path d="M6.15338 6.46002L-5.28031e-07 6.46003L-3.46196e-07 8.53998L6.15338 8.53998L3.76241 11.0228L5.18496 12.5L10 7.5L5.18496 2.5L3.76241 3.9772L6.15338 6.46002Z" fill="#1363DF" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.62947 4L9.5185 7H5V6.46003L6.15338 6.46002L5 5.26233V4H6.62947ZM8.01778 4H13V7H10.8663C10.8265 6.93118 10.7778 6.86608 10.7203 6.80634L8.01778 4Z" fill="#1363DF" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5185 8L6.62947 11H6V8.69925L6.15338 8.53998H6V8H9.5185ZM10.8663 8H14V11H8.01778L10.7203 8.19366C10.7778 8.13392 10.8265 8.06882 10.8663 8Z" fill="#1363DF" />
        </svg>
      </button>

      <button
        type="button"
        class="btn exclude"
        matTooltip="Exclude"
        matTooltipClass="emd-tip-mat"
        cdkMenuItem
        [class.disabled]="!draft.length || draft.length === activeChip!.options.length"
        [disabled]="!draft.length || draft.length === activeChip!.options.length"
        (click)="apply('exclude')"
      >
        <svg width="25" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="8" height="3" fill="#D11044" />
          <rect y="12" width="8" height="3" fill="#D11044" />
          <path d="M11.1534 6.46002L5 6.46003L5 8.53998L11.1534 8.53998L8.76241 11.0228L10.185 12.5L15 7.5L10.185 2.5L8.76241 3.9772L11.1534 6.46002Z" fill="#D11044" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5 7H10V6.46003L5 6.46003V7ZM10 5.26234L8.78436 4H10V5.26234ZM4 7H2V4H7.76266C7.76816 4.24237 7.86131 4.48312 8.0421 4.67086L8.80207 5.46003L5 5.46003C4.44772 5.46003 4 5.90774 4 6.46003V7Z" fill="#D11044" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.78436 11H9V10.7761L8.78436 11ZM9 8.53998L5 8.53998V8H9V8.53998ZM7.76267 11H1V8H4V8.53998C4 9.09226 4.44772 9.53997 5 9.53998L8.80207 9.53998L8.0421 10.3291C7.86131 10.5169 7.76816 10.7576 7.76267 11Z" fill="#D11044" />
        </svg>
      </button>

      <button
        type="button"
        class="btn exclude"
        matTooltip="Clear selection"
        matTooltipClass="emd-tip-mat"
        cdkMenuItem
        [class.disabled]="draft.length === activeChip!.options.length"
        [disabled]="draft.length === activeChip!.options.length"
        (click)="clearSelection()"
      >
        <svg width="25" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1233 0C15.6075 0 16 0.392499 16 0.876682C16 1.05902 15.9432 1.23684 15.8373 1.3854L12.2592 6.40765C11.9677 6.35237 11.6669 6.32344 11.3594 6.32344C8.70842 6.32344 6.55938 8.47248 6.55938 11.1234C6.55938 12.7503 7.3687 14.1881 8.60667 15.0562L7.97832 15.4751C7.19837 15.995 6.14461 15.7843 5.62468 15.0044C5.43971 14.7268 5.34054 14.401 5.33964 14.0675L5.32513 8.72486L0.159683 1.38108C-0.11886 0.985049 -0.0236423 0.438156 0.372391 0.159613C0.520046 0.055766 0.696221 0 0.876751 0H15.1233Z" fill="#D11044" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2 14.3219C12.9673 14.3219 14.4 12.8892 14.4 11.1219C14.4 9.35456 12.9673 7.92188 11.2 7.92188C9.43269 7.92188 8 9.35456 8 11.1219C8 12.8892 9.43269 14.3219 11.2 14.3219ZM11.5953 11.4889H12.8V10.7642H11.5953L11.6 10.7643H10.8L10.7953 10.7642H9.60001V11.4889L10.7953 11.4889L11.5953 11.4889Z" fill="#D11044" />
        </svg>
      </button>
    </div>

    <div class="search-container">
      <input
        type="text"
        class="search-bar"
        placeholder="Search..."
        [(ngModel)]="searchTerm"
      />
    </div>

    <div class="select-all-container" *ngIf="activeChip?.multi && visibleOptions.length">
      <input type="checkbox" [checked]="areAllSelected()" (change)="toggleSelectAll()" />
      <span>{{ searchTerm ? '(Select All Search Results)' : 'Select All' }}</span>
    </div>

    <div class="menu-options emd-menu-empty" *ngIf="!visibleOptions.length">
      <div>No data found</div>
    </div>

    <div
      class="menu-options"
      *ngIf="visibleOptions.length"
      [class.dynamicHeight]="visibleOptions.length > 9"
    >
      <!-- Multi-select: rows toggle the working draft; the header commits. -->
      <ng-container *ngIf="activeChip?.multi">
        <div
          class="du-badge-option"
          *ngFor="let option of visibleOptions"
          [class.selected]="isSelected(option)"
          (click)="toggle(option)"
        >
          <span class="du-badge-option-label">
            <!-- Non-interactive: the row handles the click, so the checkbox
                 can't toggle twice. -->
            <input type="checkbox" [checked]="isSelected(option)" tabindex="-1" />
            <span>{{ option }}</span>
          </span>
        </div>
      </ng-container>

      <!-- Single-select: a pick applies immediately and, via cdkMenuItem,
           closes the dropdown. Checkbox marker matches the filter-badges menu. -->
      <ng-container *ngIf="!activeChip?.multi">
        <div
          class="du-badge-option"
          cdkMenuItem
          *ngFor="let option of visibleOptions"
          [class.selected]="isSelected(option)"
          (click)="toggle(option)"
        >
          <span class="du-badge-option-label">
            <input type="checkbox" [checked]="isSelected(option)" tabindex="-1" />
            <span>{{ option }}</span>
          </span>
        </div>
      </ng-container>
    </div>

  </div>
</ng-template>

<!-- Time Range panel: the app's filter-badges dual-month calendar, reused
     as-is (the same <app-dual-calendar> its #datemenu renders for a D/W range).
     Hosted in a cdkConnectedOverlay with a transparent backdrop, triggered by
     the chip; the calendar ships its own "Date Selection" header, inputs and
     Clear/Apply. -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="dateRangeOrigin"
  [cdkConnectedOverlayOpen]="dateRangeOpen"
  [cdkConnectedOverlayPositions]="dateRangePositions"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="closeDateRange()"
  (detach)="closeDateRange()"
>
  <div class="emd-daterange-panel" [style.--emd-accent]="accentColor || null">
    <app-dual-calendar
      [DateConfig]="dateConfig"
      [selectedData]="dateSelectedData"
      (applyFilter)="onDualCalendarApply($event)"
    ></app-dual-calendar>
  </div>
</ng-template>
